import cx from 'classnames';

import { CrossButton } from './CrossButton';
import style from './ModalMinimalHeader.module.css';

export type ModalMinimalHeaderProps = {
    dark?: boolean;
    onClose?: () => void;
};

export function ModalMinimalHeader({ dark, onClose }: ModalMinimalHeaderProps) {
    return (
        <div className={cx(style.header, { [style.dark]: dark })}>
            <div className={style.rightButton}>
                {onClose ? <CrossButton onClick={onClose} className={style.crossButton} /> : null}
            </div>
        </div>
    );
}
